import { UseHenryQuestionniareProps } from "../useHenryQuestionnaire";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { BodyMediumRegular, Button, HenryTips } from "@manifesthhqinc/ui-library";
import Spacing from "../../../layout/spacing";

import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Footer from "../../../components/footer";
import { FooterButtonDiv } from "../../../components/footer/styles";
import { STEP_DESTINATION_HELP_RESULT } from "../../../class/transferDetails";
import { useEffect } from "react";

const MethodologyScreen = (props: UseHenryQuestionniareProps) => {
  const { goToScreen, setIsLoading } = props;

  useEffect(() => {
    setIsLoading(true);
    return () => setIsLoading(false);
  }, []);

  return (
    <TransitionWrapper>
      <ScrollableContainer name="methodology-screen">
        <Container>
          <Spacing vertical="20" />
          <HenryTips isBold className="justify-content--center">
            What’s our methodology?
          </HenryTips>
          <Spacing vertical="20" />
          <BodyMediumRegular>
            Manifest uses your answers to evaluate your current financial situation, investing style, and future saving
            needs. After transferring millions of dollars in retirement savings, we’ve studied the factors that matter
            most. Our suggestions are based on the highest fiduciary standards.
            <br />
            <br />
            <br />
            Regardless of your final decision, consolidating is smart. If you need additional help, we advise you to
            consult your accountant or financial advisor.
          </BodyMediumRegular>
        </Container>
      </ScrollableContainer>

      <Footer>
        <FooterButtonDiv>
          <Button size="large" onClick={() => goToScreen(STEP_DESTINATION_HELP_RESULT)}>
            Go back
          </Button>
        </FooterButtonDiv>
      </Footer>
    </TransitionWrapper>
  );
};

export default MethodologyScreen;
